import React from "react";
import "../styles/roastedCoffee.css";
import RoastedCoffeeBG from "../assets/images/Roasted_Coffee_Bg.jpg";

export default function RoastedCoffee() {
  return (
    <div className="roasted-coffee-page">

      {/* Spacer is now zero height — no white bar */}
      <div className="nav-spacer"></div>

      {/* Hero Section */}
      <div
        className="hero-section"
        style={{ backgroundImage: `url(${RoastedCoffeeBG})` }}
      >
        <div className="hero-overlay"></div>

        <div className="hero-content">
          <div className="hero-badge">
            <span>PREMIUM QUALITY</span>
          </div>

          <h1 className="hero-title">ROASTED COFFEE BEANS</h1>

          <p className="hero-subtitle">
            Crafted With Passion. Delivered With Excellence.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        <div className="container">
          <section className="roast-info-section">
            <div className="section-header">
              <div className="section-badge">
                <div className="badge-line left"></div>
                <span className="badge-text">OUR ROAST</span>
                <div className="badge-line right"></div>
              </div>

              <h2 className="section-title">From Farm to Cup</h2>

              <p className="section-description">
                Aditya Exports Ventures stays committed to crafting exceptional roasted coffee
                with unmatched freshness and flavour.
              </p>
            </div>

            <div className="roast-card">
              <div className="roast-card-content">
                <p>
                  From farm to cup, Aditya Exports Ventures remains as passionate as ever
                  in crafting extraordinary coffee that delivers rich flavour and aroma
                  appreciated by coffee connoisseurs.
                </p>

                <p>
                  Starting with ethical growing practices, our physical and technical
                  coffee knowledge and experience allow us to obtain the best out of
                  each specific type of coffee.
                </p>

                <p>
                  With Aditya Exports Ventures' processes, you can be assured the coffee
                  you consume is held to the highest standard of taste and freshness.
                </p>
              </div>
            </div>

          </section>
        </div>
      </div>

    </div>
  );
}
